module.exports = __webpack_public_path__ + "static/media/twitter.aa185d1b.png";